import React from "react";
import { useField } from "formik";
import Select from "../common/src/select/Selector";
import _helperStatusFormik from "../../../Helpers/StatusFormik";

const SelectFormik = (props) => {
  const [field, meta, helpers] = useField(props);
  return (
    <Select {...props} {...field} state={_helperStatusFormik(meta)}>
      {props.children}
    </Select>
  );
};

export default SelectFormik;
